import { Platform } from 'react-native'

const iosLikeShadow = {
  shadowColor: 'rgba(0, 0, 0, 0.25)',
  shadowOffset: { width: 2, height: 3 },
  shadowOpacity: 0.25,
  shadowRadius: 6,
}

export const ButtonShadow = Platform.select({
  ios: iosLikeShadow,
  android: {
    elevation: 4,
  },
  // RNW maps shadow* → CSS box-shadow. Without this, web chips/buttons are flat.
  default: iosLikeShadow,
})
